import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom'; // Ajout de Link
import { useAuth } from './AuthContext';
import '../../styles/app.css';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    console.log('Submitting login form with email:', email);
    try {
      const success = await login(email, password);
      if (success) {
        console.log('Login successful, navigating to home...');
        navigate('/');
      } else {
        console.log('Login failed');
        setError('Login failed');
      }
    } catch (err) {
      console.error('An error occurred during login:', err);
      setError('An error occurred during login');
    }
  };

  return (
    <div className="container">
      <h2>Se connecter</h2>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <form onSubmit={handleSubmit}>
        <div>
          <label>Email:</label>
          <input
            type="email"
            value={email}
            onChange={(e) => {
              console.log('Email changed to:', e.target.value);
              setEmail(e.target.value);
            }}
            required
          />
        </div>
        <div>
          <label>Mot de passe:</label>
          <input
            type="password"
            value={password}
            onChange={(e) => {
              console.log('Password changed');
              setPassword(e.target.value);
            }}
            required
          />
        </div>
        <button type="submit">Login</button>
        <div className="forgot-password-link">
          <Link to="/forgot-password">Mot de passe oublié ?</Link>
        </div>
      </form>
    </div>
  );
}

export default Login;
